import React, { useCallback, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button, TextField, Switch, MenuItem, Typography } from "@mui/material";
// import { icons, months, appConstants } from "../../helpers/constants";

import { Slide, Grid, Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../interceptor/interceptor";
import CircularProgress from "@mui/material/CircularProgress";

import { budgetService } from "../services/budget.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function MonthlyValDialog(props) {
  const {
    open,
    closeHandler,
    budgetId
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [inputField, setInputField] = React.useState({
    budget_id: "",
    user_id: localStorage.getItem("user_text_obj_data1"),
    name: "",
    amount: "",
  });

  const inputsHandler = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  const inputsHandler2 = (newVal) => {
    setInputField({ ...inputField, transaction_date: newVal });
  };

  const handleClose = () => {
    closeHandler();
  };

  useEffect(() => {
    setInputField({
      ...inputField,
      budget_id: budgetId,
    //   name: budgetName,
    //   amount: budgetAmount,
    });
  }, [budgetId]);

  const handleSubmit = async () => {
    try {
      let obj = {};
      obj = { ...inputField };
      obj.user_id = localStorage.getItem("user_text_obj_data1");
      obj.monthStartDate = 5;
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=add_transaction`,
        obj
      );
      setInputField({
        ...inputField,
        amount: "",
        note: "",
      });

      setIsLoading(false);
      toast(res.data.message);
      closeHandler();
    //   refreshData();
    } catch (e) {
      toast.info(`Error: ${e}`, { type: "error" });
    }
  };

  return (
    <div>
      {/* <ToastContainer /> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="modalBudgetForm"
      >
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        />
        <DialogTitle>
          {inputField.budget_id != "0" ? (
            <>{inputField.name}</>
          ) : (
            <>Save Payment</>
          )}
        </DialogTitle>

        <form className="budget-form">
          <DialogContent>
            {/* <Typography>{inputField.name}</Typography> */}
            {/* <TextField
              value={inputField.name}
              onChange={inputsHandler}
              style={{ marginBottom: "10px", width: "100%", color: "#fff" }}
              type="text"
              label="Name"
              variant="outlined"
              name="name"
              disabled={true}
            /> */}
            <br />
            <TextField
              style={{ marginBottom: "20px", width: "100%" }}
              name="amount"
              type="text"
              label="Amount"
              variant="outlined"
              value={inputField.amount}
              onChange={inputsHandler}
            />
            <br />
            <br />

            <TextField
              name="note"
              type="text"
              label="Note"
              variant="outlined"
              value={inputField.note}
              onChange={inputsHandler}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={handleSubmit} variant="outlined">Save</Button>
          </DialogActions>
        </form>
      </Dialog>
      {isLoading == false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}
    </div>
  );
}
